import styled from "styled-components";

const TitleTemplatesGroupStyled = styled.div``;
const Title = styled.div`
  font-size: 19px;
  color: #363636;
`;
const SubTitle = styled.div`
  font-size: 12px;
  color: gray;
  margin-bottom:20px;
`;

export { TitleTemplatesGroupStyled, Title, SubTitle };
